export const CUSTOMER_LIST = "CUSTOMER_LIST";
export const CUSTOMER_PAGINATION = "CUSTOMER_PAGINATION";
export const CUSTOMER_COMPANY_LIST = "CUSTOMER_COMPANY_LIST";